var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 15.889,
    viewBox: "0 0 22 15.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-bars",
    d: "M21.083,124.5H.917a.917.917,0,1,1,0-1.833H21.083a.917.917,0,1,1,0,1.833Zm0,0",
    transform: "translate(0 -115.64)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-bars",
    d: "M17.686,1.833H.769A.853.853,0,0,1,0,.917.853.853,0,0,1,.769,0H17.686a.853.853,0,0,1,.769.917A.853.853,0,0,1,17.686,1.833Zm0,0",
    transform: "translate(3.545)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "icon-bars",
    d: "M17.686,247.165H.769a.931.931,0,0,1,0-1.833H17.686a.931.931,0,0,1,0,1.833Zm0,0",
    transform: "translate(3.545 -231.277)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOpen);
export default __webpack_public_path__ + "static/media/menu-open.00ef2910b3ecfae90902f6f22c07dc43.svg";
export { ForwardRef as ReactComponent };